import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('alumfab_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let lastGateAt = 0;

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const path = window.location.pathname;
      if (path !== '/login') {
        localStorage.removeItem('alumfab_token');
        window.location.href = '/login';
      }
    } else if (status === 402) {
      // Freemium gating: show one friendly upgrade prompt with a clear CTA.
      const detail = err?.response?.data?.detail || 'Anda telah mencapai batas paket. Upgrade untuk melanjutkan.';
      const now = Date.now();
      if (now - lastGateAt > 1200 && window.location.pathname !== '/langganan') {
        lastGateAt = now;
        toast.warning(detail, {
          id: 'feature-gate',
          duration: 6000,
          action: {
            label: 'Upgrade',
            onClick: () => { window.location.href = '/langganan'; },
          },
        });
      }
      // Mark so component-level catches can skip a duplicate toast.
      err.__gated = true;
    }
    return Promise.reject(err);
  }
);

export default api;
